/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Text } from 'bold-ui'
import { useLembretesCardQuery } from 'graphql/hooks.generated'
import { useMemo } from 'react'
import { LembreteFormModel } from 'view/atendimentos/detail/components/modals/lembretes/components/LembreteForm'
import { mergeSortLembretes } from 'view/atendimentos/detail/components/modals/lembretes/mergeSortLembretes'
import { paginateLembretes } from 'view/atendimentos/detail/components/modals/lembretes/paginateLembretes'

import { ContentCardSection } from '../components/ContentCardSection'
import { LembretesListCard } from './LembretesListCard'

export interface LembretesCardProps {
  prontuarioId: ID
  lembretesCache: LembreteFormModel[]
}

export function LembretesCard({ prontuarioId, lembretesCache }: LembretesCardProps) {
  const classes = styles()
  const { data, loading } = useLembretesCardQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      lembretesQueryInput: {
        prontuarioId,
      },
    },
  })

  const lembretesCacheDatabase = useMemo(() => mergeSortLembretes(data?.lembretes ?? [], lembretesCache ?? []), [
    data,
    lembretesCache,
  ])
  const lembretesFiltered = useMemo(() => lembretesCacheDatabase.filter((lembrete) => lembrete.ultimoLembrete?.ativo), [
    lembretesCacheDatabase,
  ])
  const paginateLembretesResult = useMemo(() => paginateLembretes(lembretesFiltered, { page: 0, size: 5 }), [
    lembretesFiltered,
  ])

  const previas = paginateLembretesResult.lembretes
  const hasLembretes: boolean = useMemo(() => previas && previas.length !== 0, [previas])

  return (
    <ContentCardSection isLoading={loading} messageLoading='Carregando dados dos lembretes'>
      {hasLembretes ? (
        <ul css={classes.ul}>
          <LembretesListCard lembretes={previas} />
        </ul>
      ) : (
        <Text component='p' fontStyle='italic'>
          Clique para registrar um lembrete.
        </Text>
      )}
    </ContentCardSection>
  )
}

const styles = () => ({
  ul: css`
    padding: 0rem;
    margin: 0rem;
  `,
})
